import React from 'react'
import { Modal } from 'antd'
import { Form, Icon, Input, Button, /* Checkbox, */ notification } from 'antd'
import { Link } from 'react-router-dom'
import { Types } from 'store/actions/auth'

import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const FormItem = Form.Item

class SignIn extends React.Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => this.props.changeRoute('/'), 300)
  }

  handleSubmit = e => {
    e.preventDefault()
    const { validateFields, getFieldsValue } = this.props.form

    validateFields((err, values) => {
      if (err) {
        notification['error']({
          message: 'Validation Error...',
          description: 'Please enter correct information.',
          duration: 3
        })
      } else {
        const data = getFieldsValue()
        this.props.signIn(data.email, data.password)
      }
    })
  }

  render () {
    const { user, global, ...props } = this.props
    const { getFieldDecorator } = props.form
    return (
      <Modal
        wrapClassName='vertical-center-modal'
        visible={this.state.visible}
        footer={null}
        onCancel={this.onClose}
      >
        <div className='signin'>
          <img className='logo' src={imgLogo} alt='logo' />
          <p className='description' />

          <div className='form'>
            <Form onSubmit={this.handleSubmit}>
              <FormItem>
                {getFieldDecorator('email', {
                  rules: [
                    { required: true, message: 'Please input your username!' }
                  ]
                })(
                  <Input
                    prefix={
                      <Icon
                        type='mail'
                        style={{ color: 'rgba(255, 255, 255, .8)' }}
                      />
                    }
                    placeholder='Email'
                  />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password', {
                  rules: [
                    { required: true, message: 'Please input your Password!' }
                  ]
                })(
                  <Input
                    prefix={
                      <Icon
                        type='lock'
                        style={{ color: 'rgba(255, 255, 255, .8)' }}
                      />
                    }
                    type='password'
                    placeholder='Password'
                  />
                )}
              </FormItem>
              <FormItem>
                {/* {getFieldDecorator('remember', {
                  valuePropName: 'checked',
                  initialValue: true,
                })(
                  <Checkbox>Remember me</Checkbox>
                )} */}
                {/* <div>
                  <Link className="form-forgot" to="/user/password/forgot">Forgot password?</Link>
                </div> */}
                <Button
                  size='large'
                  ghost
                  htmlType='submit'
                  className='form-button'
                  loading={global.status[Types.SIGN_IN] === 'request'}
                >
                  Sign In
                </Button>
                <div style={{ textAlign: 'center' }}>
                  {/* <Link to="/user/signup">Not Registered? Register now!</Link> */}
                  <Link to='/user/password/forgot'>Forgot password?</Link>
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

export default Form.create()(SignIn)
